import { render } from "./ReportForm.vue?vue&type=template&id=2789c360&scoped=true"
import script from "./ReportForm.vue?vue&type=script&lang=js"
export * from "./ReportForm.vue?vue&type=script&lang=js"

import "./ReportForm.vue?vue&type=style&index=0&id=2789c360&lang=css"
import "./ReportForm.vue?vue&type=style&index=1&id=2789c360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2789c360"]])

export default __exports__